"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@requestnetwork/utils");
/**
 * Collection of utils functions related to the library, meant to simplify its use.
 */
exports.default = {
    formatGetRequestFromIdError,
    /**
     * Returns the current timestamp in second
     *
     * @returns current timestamp in second
     */
    getCurrentTimestampInSecond: utils_1.getCurrentTimestampInSecond,
};
/**
 * Formats a human readable message from ignored transactions
 *
 * @param requestAndMeta return from GetRequestFromId
 * @returns human readable message
 */
function formatGetRequestFromIdError(requestAndMeta) {
    if ((requestAndMeta.meta.ignoredTransactions &&
        requestAndMeta.meta.ignoredTransactions.length !== 0) ||
        requestAndMeta.meta.transactionManagerMeta.ignoredTransactions.length !== 0) {
        return `Invalid transaction(s) found: ${JSON.stringify(requestAndMeta.meta.transactionManagerMeta.ignoredTransactions
            .concat(requestAndMeta.meta.ignoredTransactions || [])
            .filter((tx) => tx !== null))}`;
    }
    return 'No transaction found';
}
